// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-buttons-y7ygwq{align-items:center;gap:8px;display:flex}.tip-content-ldnrz_{flex-direction:column;padding:12px;font-size:14px;font-style:normal;font-weight:400;line-height:18px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"action-buttons": `action-buttons-y7ygwq`,
	"actionButtons": `action-buttons-y7ygwq`,
	"tip-content": `tip-content-ldnrz_`,
	"tipContent": `tip-content-ldnrz_`
};
export default ___CSS_LOADER_EXPORT___;
